import { render, staticRenderFns } from "./WarehouseComponent.vue?vue&type=template&id=5ad0fcfb"
import script from "./WarehouseComponent.vue?vue&type=script&lang=js"
export * from "./WarehouseComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports